export const SITE_NAME = 'CuttingEdge DevOps';
// Production host. REACT_APP_SITE_URL overrides it at build time for other environments. No trailing slash.
export const SITE_URL = (process.env.REACT_APP_SITE_URL || 'https://www.edgedevops.net').replace(/\/+$/, '');
export const DEFAULT_OG_IMAGE = '/og.jpg';
export const SITE_LOCALE = 'en_US';
export const absoluteUrl = (path: string) =>
  /^https?:\/\//.test(path) ? path : `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
export const CONTACT_EMAIL = 'cuttingedgedevops1@gmail.com';
export const CALENDLY_URL = 'https://calendly.com/cuttingedgedevops1';
export const DEFAULT_DESCRIPTION =
  'CuttingEdge DevOps is a Puerto Rico software studio that designs, builds, secures, and maintains custom websites, mobile apps, and cloud platforms.';
